import Majestic from "./route/Majestic";
import SkyOne from "./route/SkyOne";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Majestic />} />
        <Route path="/project/skyone" element={<SkyOne />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
